<div class="filters-container">
  <cbre-filters
    [filters]="filters"
    [aggregations]="aggregations()"
    (valueChanges)="handleValueChanges($event)"
    (filtersChange)="handleFilterChange($event)"
    (removeFilter)="handleRemoveFilter($event)"
  >
  </cbre-filters>

  <div class="fx--border__bottom fx--mt-20 fx--mb-12"></div>

  <div class="fx--h fx--ali-center search-bar-wrapper">
    <!-- Search input -->
    <div class="fx--column-5">
      <mat-form-field appearance="outline" class="miq-form-input">
        <input
          matInput
          [formControl]="searchCtrl"
          type="text"
          [placeholder]="searchPlaceholder()"
          (keyup.enter)="handleSearchChange($event)"
        />
        <div class="search-bar__input-suffix" matSuffix>
          <mat-icon class="search-bar__clear-icon" *ngIf="searchCtrl.value" (click)="clearSearch()">clear</mat-icon>
          <mat-icon class="search-bar__icon" *ngIf="!searchCtrl.value">search</mat-icon>
        </div>
      </mat-form-field>
    </div>

    <!-- List selection button — in the same row, right of search -->
    <div class="fx--pl-md">
      <cbre-list-selection-button
        [listOptions]="listOptions"
        [selectedValues]="selectedListValues()"
        [listBtnConfig]="listBtnConfig()"
        (selectionChange)="handleListSelectionChange($event)"
      >
      </cbre-list-selection-button>
    </div>
  </div>
</div>
